export const RASA_TIME_PICKER_FORMAT = 'hh:mm a'